import * as React from "react";
import { Typography } from "@material-ui/core";
import styled, { css } from "styled-components";
import { useTheme } from "@material-ui/styles";
import { Theme } from "../../../theme";

const StyledSection = styled.section`
  ${({ theme }: { theme: Theme }) => {
    return css`
      width: 700px;
    
      .form{
          padding-left:100px;
          padding-right:100px;
          padding-bottom:125px;
          flex-basis: 700px;
          ${theme.breakpoints.down("sm")}{
              padding-left: ${theme.spacing(2)}px
              padding-right: ${theme.spacing(2)}px
          }
      }
      .title{
          margin-top: ${theme.spacing(3)}px
      }
      .subText{
          margin-top: ${theme.spacing(6)}px
      }
    `;
  }};
`;

export interface SignoutProps {
  goToSignin: () => void;
}

const Signout: React.FC<SignoutProps> = props => {
  const theme: Theme = useTheme();

  return (
    <>
      <StyledSection theme={theme}>
        <div className="form">
          <>
            <Typography className="title" variant="h2">
              Logged out
            </Typography>
            <Typography color="textSecondary" gutterBottom>
              You have successfully logged out
            </Typography>
            <Typography
              className="subText"
              color="textSecondary"
              variant="body1"
              onClick={props.goToSignin}
              style={{ cursor: "pointer" }}
            >
              Sign back in
            </Typography>
          </>
        </div>
      </StyledSection>
    </>
  );
};

export default Signout;
